import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const PdfViewer = ({ fileUrl }) => {
    const [secureUrl, setSecureUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!fileUrl) {
            setError("PDF URL not found");
            return;
        }

        let objectUrl;

        const loadPdf = async () => {
            try {
                setLoading(true);
                setError("");

                const res = await fetch(fileUrl);

                if (!res.ok) {
                    throw new Error("Unable to load PDF");
                }

                const blob = await res.blob();
                objectUrl = URL.createObjectURL(blob);
                setSecureUrl(objectUrl);
            } catch (err) {
                setError("PDF not available");
            } finally {
                setLoading(false);
            }
        };

        loadPdf();

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [fileUrl]);

    // Disable right-click inn PDF container
    useEffect(() => {
        const disableRightClick = (e) => {
            const pdfContainer = document.getElementById("pdf-container");
            if (pdfContainer && pdfContainer.contains(e.target)) {
                e.preventDefault();
            }
        };

        document.addEventListener("contextmenu", disableRightClick);
        return () => document.removeEventListener("contextmenu", disableRightClick);
    }, []);

    return (
        <Box
            id="pdf-container"
            sx={{
                width: "100%",
                height: "100%",
                border: "1px solid #ccc",
                borderRadius: 2,
                overflow: "hidden",
                userSelect: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
            }}
        >
            {loading && <CircularProgress />}

            {error && (
                <Typography color="error">
                    {error}
                </Typography>
            )}

            {!loading && !error && secureUrl && (
                <iframe
                    src={`${secureUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                    title="Secure PDF Viewer"
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                />
            )}
        </Box>
    );
};

export default PdfViewer;